module.exports = __webpack_public_path__ + "static/img/jx.2e3a1736.png";